<main class="meeting-ended" role="status">
  <nova-icon name="video_camera" size="medium" [ariaHidden]="true" />
  <h1>{{ titleKey() | translate }}</h1>
  <p>{{ messageKey() | translate }}</p>
</main>
